import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { provideRouter, RouterModule, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CustomerSelectionModule } from '@next/arable-lib/customer-selection';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { IgnoreStatusOfflinePatterns } from '@next/core-lib/components';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideStore, provideState } from '@ngrx/store';

import { AdviceModule } from './advice/advice.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';

import { CopyAdviceModule } from './copy-advice/copy-advice.module';

import { FieldAdviceCustomerSelectionCustomConfigComponent } from './customer-selection-custom-config/customer-selection-custom-config.component';

import { EnvironmentalImpactModule } from './environmental-impact/environmental-impact.module';
import { LegalStandardModule } from './legal-standard/legal-standard.module';
import { OrganicMatterModule } from './organic-matter/organic-matter.module';
import { OverviewModule } from './overview/overview.module';
import { ReportsModule } from './reports/reports.module';
import { SalesOrderPeriodModule } from './sales-order-period/sales-order-period.module';
import { SharedModule } from './shared/shared.module';
import { SoilAnalysisModule } from './soil-analysis/soil-analysis.module';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent, FieldAdviceCustomerSelectionCustomConfigComponent],
  imports: [
    RouterModule,
    SharedModule,
    OverviewModule,
    AdviceModule,
    LegalStandardModule,
    SoilAnalysisModule,
    OrganicMatterModule,
    EnvironmentalImpactModule,
    SalesOrderPeriodModule,
    ReportsModule,
    CopyAdviceModule,
    MatIconModule,
    MatDialogModule,
    AgrWrapperSiteSidenavModule,
    CustomerSelectionModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([
      CoreEffects,
      I18nEffects,
      I18nBrowserEffects,
      SiteEffects,
      NavigationEffects,
      AppEffects,
    ]),
    provideState('app', appReducer),
    {
      provide: IgnoreStatusOfflinePatterns,
      useValue: ['/arable-service/organisation/customerprogress'],
      multi: true,
    },
  ],
})
export class AppModule {}
